/** Session storage key — cleared when the browser tab/session ends. */
export const SITE_ACCESS_STORAGE_KEY = 'gedoba_site_access_granted';

/** Where users land after passing the site password gate (former `/` landing). */
export const SITE_ACCESS_POST_GATE_PATH = '/reception';

export function hasSiteAccess(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(SITE_ACCESS_STORAGE_KEY) === 'true';
}

export function grantSiteAccess(): void {
  sessionStorage.setItem(SITE_ACCESS_STORAGE_KEY, 'true');
}

export function revokeSiteAccess(): void {
  sessionStorage.removeItem(SITE_ACCESS_STORAGE_KEY);
}

export function isSiteAccessGatePath(pathname: string): boolean {
  return pathname === '/';
}
